var map = {
	"./earth.png": 64,
	"./earth_era.png": 34,
	"./galaxy.png": 65,
	"./galaxy_era.png": 35,
	"./moon.png": 66,
	"./moon_era.png": 36,
	"./planet.png": 37,
	"./sun.png": 67,
	"./sun_era.png": 38
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12;